import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosConfig';
import { CircularProgress, Box } from '@mui/material';

const AdminRoute = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        // Try to access an admin endpoint to check if user is admin
        // We'll use a simple endpoint that requires admin access
        await axiosInstance.get('/api/analytics');
        setIsAdmin(true);
      } catch (err) {
        if (err.response?.status === 403) {
          setIsAdmin(false);
        } else if (err.response?.status === 401) {
          setIsAdmin(false);
        } else {
          // Other errors - assume not admin for safety
          setIsAdmin(false);
        }
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminStatus();
  }, []);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;






